import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";
import objectToFormData from "../../../utils/objectToFormData"

export const getInstallers = params => ({ type: "GET_INSTALLERS", params })
export const getInstallersRequest = () => ({ type: "GET_INSTALLERS_REQUEST" })
export const getInstallersSuccess = payload => ({ type: "GET_INSTALLERS_SUCCESS", payload })
export const getInstallersFailed = error => ({ type: "GET_INSTALLERS_FAILED", error })

export function* getInstallersSaga({params}) {
    yield put(getInstallersRequest())
    try {
        let { data: payload } = yield call(axios,`/installers?${global.string_to_qs(params)}`)
        yield put(getInstallersSuccess(payload))
    } catch(err){
        yield put(getInstallersFailed(err))
    }
}


export const postInstallers = ({ CountryId, age, hourly_rate, job_status, profile_picture }) => ({ type: "POST_INSTALLERS", CountryId, age, hourly_rate, job_status, profile_picture })
export const postInstallersRequest = () => ({ type: "POST_INSTALLERS_REQUEST" })
export const postInstallersSuccess = payload => ({ type: "POST_INSTALLERS_SUCCESS", payload })
export const postInstallersFailed = error => ({ type: "POST_INSTALLERS_FAILED", error })


export function* postInstallersSaga({ 
    CountryId, age, hourly_rate, job_status, profile_picture
}) {
    yield put(postInstallersRequest())
    // alert(JSON.stringify({CountryId, age, hourly_rate, job_status, profile_picture}))
    try {
        let { data: payload } = 
            yield call(axios,{ 
                data: objectToFormData({ 
                    CountryId: Number(CountryId), 
                    age: Number(age), hourly_rate: Number(hourly_rate), 
                    job_status, profile_picture
                }), 
                url: "/installers", 
                method: "post",
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
        yield put(postInstallersSuccess(payload))
    } catch(err){
        yield put(postInstallersFailed(err))
    }
}

export default function* installersSagaWatcher() {
    yield takeEvery("GET_INSTALLERS", getInstallersSaga)
    yield takeEvery("POST_INSTALLERS", postInstallersSaga)
}